import api from '../api'

export default {
    namespaced: true,
    state: {
        mttBannerList: [],
        mttBannerListTotal: 0,
    },
    mutations: {
        setDataMttBannerList(state, info) {
            state.mttBannerList = info.beanList;
            state.mttBannerListTotal = info.total
        }
    },
    actions: {
        getBannerList({commit}, params) {
            return api.post('/banners/list', '轮播图列表', params).then(res => {
                commit('setDataMttBannerList', res.data)
            })
        },
        addBanner({dispatch}, params) {
            return api.post('/banners/add', '新增banner', params).then(()=>{
                dispatch('getBannerList',{type:params.type})
            })
        },
        updateBanner({dispatch}, {params,page}) {
            return api.post('/banners/update', '修改banner', params).then(()=>{
                dispatch('getBannerList',{type:params.type,page})
            })
        },
        deleteBanner({dispatch}, {bannerIds,page,type}) {
            return api.post('/banners/delete', '删除banner', {bannerIds,type}).then(()=>{
                dispatch('getBannerList',{page,type})
            })
        }
    }
}